import React from 'react';
import { useSelector } from 'react-redux';

import Heading from '@starbucks-web/pattern-library/lib/components/heading';
import ContentColumn from '@starbucks-web/pattern-library/lib/components/content-column';
import Icon from '@starbucks-web/pattern-library/lib/components/icon';
import Carousel from '@starbucks-web/pattern-library/lib/components/carousel';

import { isMobileViewportSelector } from 'shared/app/bundles/viewport';

import styles from './styles.cssm';
import { getTiers } from './tiers';
import { FormattedMessage } from 'react-intl';
import messages from './messages';

const MembershipTierCard = ({
  name,
  tierRangeText,
  items,
  color,
  bgColor,
  iconStrokeColor,
}) => {
  return (
    <ContentColumn
      className={`${styles.tierCardContainer} text-semibold text-center ${bgColor} ${color}`}
      innerClassName="flex-column flex-auto"
    >
      <Heading className="text-bold" tagName="h3">
        {name}
      </Heading>
      <p>{tierRangeText}</p>
      <Heading className="hiddenVisually" tagName="h4">
        <FormattedMessage {...messages.benefitsList} values={{ tier: name }} />
      </Heading>
      <ul className="flex flex-column mt4">
        {items.map((item) => {
          const { icon, text } = item;
          return (
            <li className="flex mb4 text-left" key={item.text}>
              <Icon
                className={`${iconStrokeColor} mr1`}
                path={icon.path}
                role="presentation"
                size="24px"
              />
              <span className={`${styles.itemText} ml2 text-xxs`}>{text}</span>
            </li>
          );
        })}
      </ul>
    </ContentColumn>
  );
};

const MembershipTiers = () => {
  const isMobileViewport = useSelector(isMobileViewportSelector);
  const tiers = getTiers();
  return (
    <div className="sb-global-gutters flex flex-column items-center text-center color-greenOnPrimary py9">
      <Heading className={`text-bold`} size="xl" tagName="h2">
        <FormattedMessage {...messages.header} />
      </Heading>
      <p className={`${styles.bodyText} text-xs mt2 md-mt3`}>
        <FormattedMessage {...messages.subheader} />
      </p>
      <div className="flex flex-row flex-auto mt4 md-mt5" style={{ gap: 16 }}>
        {isMobileViewport ? (
          <Carousel
            activePaginatorClassName={styles.activePageControl}
            carouselClassName={styles.carousel}
            controlClassName={styles.pageControls}
            showPagerButtons={false}
            showPaginator
            sliderClassName={styles.slider}
            slidesPerPage={1}
          >
            {tiers.map((tier, index) => {
              return (
                <div
                  className={`${styles.wrapper} flex`}
                  key={`${tier.name}-${index}`}
                >
                  <MembershipTierCard {...tier} />
                </div>
              );
            })}
          </Carousel>
        ) : (
          tiers.map((tier, index) => {
            return (
              <MembershipTierCard {...tier} key={`${tier.name}-${index}`} />
            );
          })
        )}
      </div>
    </div>
  );
};

export default MembershipTiers;
